import { Box, Card, CardContent, Grid, Skeleton } from "@mui/joy";

export function MaterialsSkeleton() {
    return (
        <Box>
            {/* Missing products skeleton */}
            <Box display="flex" gap={1} flexWrap="wrap" mb={3}>
                <Skeleton variant="rectangular" width={120} height={24} sx={{ borderRadius: 6 }} />
                <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 6 }} />
                <Skeleton variant="rectangular" width={140} height={24} sx={{ borderRadius: 6 }} />
            </Box>

            {/* Product cards skeleton */}
            <Grid container spacing={1}>
                {[1, 2, 3, 4, 5].map((index) => (
                    <Grid xs={12} key={index} mb={1}>
                        <Card
                            sx={{
                                p: 1.5,
                                px: 2,
                                borderRadius: 10,
                                border: "1px solid",
                                borderColor: "divider",
                            }}
                            variant="soft"
                        >
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" gap={3}>
                                    {/* Left section - Product info */}
                                    <Box flex={1} display="flex" flexDirection="column" justifyContent="center" gap={1}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Skeleton variant="text" width={120} height={20} />
                                            <Skeleton variant="text" width={60} height={16} />
                                        </Box>
                                        <Skeleton variant="text" width={180} height={24} />
                                    </Box>

                                    {/* Middle section - Quantity control */}
                                    <Box display="flex" alignItems="center">
                                        <Skeleton
                                            variant="rectangular"
                                            width={100}
                                            height={36}
                                            sx={{ borderRadius: "40px" }}
                                        />
                                    </Box>

                                    {/* Right section - Price */}
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="center"
                                        minWidth={140}
                                        gap={0.5}
                                    >
                                        <Skeleton variant="text" width={80} height={20} />
                                        <Skeleton variant="text" width={100} height={14} />
                                    </Box>

                                    {/* Remove button */}
                                    <Box display="flex" alignItems="center">
                                        <Skeleton variant="circular" width={26} height={26} sx={{ borderRadius: 6 }} />
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Supplier comparison skeleton */}
            <Box mt={3}>
                <Box mb={2}>
                    <Skeleton variant="text" width={150} height={20} />
                    <Skeleton variant="text" width={300} height={16} sx={{ mt: 0.5 }} />
                </Box>
                <Card variant="outlined" sx={{ p: 2 }}>
                    <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: "md" }} />
                </Card>
            </Box>
        </Box>
    );
}
